(function () {
  'use strict'; // opt out of "sloppy mode" this is only applyed to this function however so will not break other code

  angular
    .module('iqxCore')
    .controller('SettingsAccountCtrl', UserSettingsAccountCtrl)

  function UserSettingsAccountCtrl($scope, FormSvc, pinSvc, toastSvc, ApplicationSvc, SweetAlert, $location, $routeParams, $http) {
    var accountSettings = this

    accountSettings.viewTab = viewTab
    accountSettings.activeTab = ''
    accountSettings.createPin = createPin
    accountSettings.doCreatePin = doCreatePin
    accountSettings.removePin = removePin
    accountSettings.deleteAccount = deleteAccount
    accountSettings.cancel = clearAndClose
    accountSettings.usingPIN = ApplicationSvc.currentUser.pinauth
    accountSettings.changePassword = changePassword
    accountSettings.doDeleteAccount = doDeleteAccount
    accountSettings.cancelAccountDeletion = cancelAccountDeletion

    activate()

    ///////////

    function activate() {
      accountSettings.activeTab = 'account'

      if ($routeParams.createPIN == "true" && accountSettings.usingPIN !== true) {
        createPin()
      }
    }

    function cancelAccountDeletion() {
      return $http.post('/api/call/NetCandidateCancelAccountDeletion', { pPersonID: ApplicationSvc.currentUser.personID })
        .then(function (res) {
          ApplicationSvc.currentUser.markedForDeletion = false
          SweetAlert.swal({
            title: 'Account Deletetion Canceled.',
            text: '',
            type: 'success'
          })
        })
    }

    function deleteAccount() {
      return FormSvc.modalForm($scope, 'deleteAccountModal', {}, 'xl', true, {}, {}, true)
    }

    function doDeleteAccount(close) {
      accountSettings.close = close
      return $http.post('/api/auth/checkpwd', { username: accountSettings.username, password: accountSettings.password })
        .then(function (res) {
          if (res.data.token) {
            accountSettings.close()

            accountSettings.username = null
            accountSettings.password = null
            return $http.post('/api/call/NetCandidateStartAccountDeletion', { pPersonID: ApplicationSvc.currentUser.personID })
              .then(function (res) {
                ApplicationSvc.currentUser.markedForDeletion = true
                return SweetAlert.swal({
                  title: 'Logout',
                  html: 'Account has been marked for deletion, deletion can take up to 24 hours<br />Do you want to logout?',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, Logout!',
                  cancelButtonText: 'No'
                })
                  .then(function (result) {
                    if (result.value) {
                      $scope.logout()
                    }
                  })
              })

          }
        })
        .catch(function (err) {
          if (err.status === 401) {
            accountSettings.username = null
            accountSettings.password = null

            SweetAlert.swal({
              title: 'Incorrect Login',
              text: 'Please enter the correct username and password',
              type: 'error',
              confirmButtonText: 'Ok'
            })
          } else {
            SweetAlert.swal({
              title: 'Error',
              html: err.message,
              type: 'error',
              confirmButtonText: 'Ok'
            })
          }
        })

    }

    function changePassword() {
      return $location.url('/changepassword')
    }

    function doCreatePin(close) {
      accountSettings.close = close
      return pinSvc.create(accountSettings.pin1, accountSettings.pin2)
        .then(function (res) {
          accountSettings.close()
          accountSettings.usingPIN = true
          $scope.$parent.$parent.$parent.$parent.usingpinauth = true
          if ($routeParams.continue) {
            window.location.href = $routeParams.continue
          }
        })
    }

    function removePin() {
      ApplicationSvc.currentUser.pinauth = false
      $scope.$parent.$parent.$parent.$parent.usingpinauth = false
      $scope.logout()
      $scope.$evalAsync(function () {
        if (ApplicationSvc.isApp !== true) {
          $location.url('/login?PINRemoved')
        } else {
          window.location.href = "/login"
        }
      })
    }

    function clearAndClose(close) {
      toastSvc.clear('pininfo')
      accountSettings.pin1 = null
      accountSettings.pin2 = null
      accountSettings.close ? accountSettings.close() : close()
    }

    function createPin() {
      return FormSvc.modalForm($scope, 'createPINModal', {}, 'xl', true, {}, {}, true)
    }

    function viewTab(tab) {
      accountSettings.activeTab = tab
    }
  }
})()
